import { API_ERROR } from "../../auth/login/actionTypes"
import {
  ADD_CARD, ADD_CARD_SUCCESSFUL,
  ADD_CARD_FAILED,
  GET_CARD_LIST, GET_CARD_LIST_SUCCESSFUL,
  GET_CARD_LIST_FAILED,
  REMOVE_CARD,
  REMOVE_CARD_SUCCESSFUL,
  DEFAULT_CARD,
  DEFAULT_CARD_SUCCESSFUL,
  GET_INVOICES,
  GET_INVOICES_SUCCESSFUL,
  GET_PLAN,
  GET_PLAN_SUCCESSFUL,
  GET_PLAN_FAILED,
  GET_INVOICES_FAILED,
  REMOVE_CARD_FAILED,
  DEFAULT_CARD_FAILED,
  ADD_BILL_ADDRESS,
  ADD_BILL_ADDRESS_FAILED,
  GET_BILL_ADDRESS_DETAILS,
  GET_BILL_ADDRESS_DETAILS_SUCCESSFUL,
  GET_BILL_ADDRESS_DETAILS_FAILED,
  ADD_BILL_ADDRESS_SUCCESSFUL,
  EDIT_BILL_ADDRESS,
  EDIT_BILL_ADDRESS_SUCCESSFUL,
  EDIT_BILL_ADDRESS_FAILED,
  RESET_CARD_ALERT,
  ADD_CARD_RESET,
  GET_TIMEZONES_LIST,
  UPDATE_TIMEZONE,
  SET_TIMEZONES_LIST,
  SET_SETUP_POPUP,
  SET_PAYEMENT_INFO,
} from "./actionTypes"

export const addCard = (card, history) => {
  return {
    type: ADD_CARD,
    payload: { card, history },
  }
}

export const addCardSuccessful = card => {
  return {
    type: ADD_CARD_SUCCESSFUL,
    payload: card,
  }
}

export const addCardFailed = card => {
  return {
    type: ADD_CARD_FAILED,
    payload: card,
  }
}

export const resetCardAlert = () => {
  return {
    type: RESET_CARD_ALERT,
  }
}


export const getCardList = card => {
  return {
    type: GET_CARD_LIST,
  }
}
export const getCardListSuccessful = card => {
  return {
    type: GET_CARD_LIST_SUCCESSFUL,
    payload: card,
  }
}
export const getCardListFailed = card => {
  return {
    type: GET_CARD_LIST_FAILED,
    payload: card,
  }
}
export const removeCard = (card, history) => {
  return {
    type: REMOVE_CARD,
    payload: { card, history },
  }
}
export const removeCardSuccessful = card => {
  return {
    type: REMOVE_CARD_SUCCESSFUL,
    payload: card,
  }
}
export const removeCardFailed = card => {
  return {
    type: REMOVE_CARD_FAILED,
    payload: card,
  }
}

export const defaultCard = (card, history) => {
  return {
    type: DEFAULT_CARD,
    payload: { card, history },
  }
}
export const defaultCardSuccessful = card => {
  return {
    type: DEFAULT_CARD_SUCCESSFUL,
    payload: card,
  }
}
export const defaultCardFailed = card => {
  return {
    type: DEFAULT_CARD_FAILED,
    payload: card,
  }
}
export const getInvoices = (invsearch, history) => {
  return {
    type: GET_INVOICES,
    payload: { invsearch, history },
  }
}
export const getInvoicesSuccessful = card => {
  return {
    type: GET_INVOICES_SUCCESSFUL,
    payload: card,
  }
}
export const getInvoicesFailed = card => {
  return {
    type: GET_INVOICES_FAILED,
    payload: card,
  }
}

export const getPlan = () => {
  return {
    type: GET_PLAN,
  }
}
export const getPlanSuccessful = card => {
  return {
    type: GET_PLAN_SUCCESSFUL,
    payload: card,
  }
}
export const getPlanFailed = card => {
  return {
    type: GET_PLAN_FAILED,
    payload: card,
  }
}

export const addBillAdd = (Add, history) => {
  return {
    type: ADD_BILL_ADDRESS,
    payload: { Add, history },
  }
}

export const addBillAddSuccessful = Add => {
  return {
    type: ADD_BILL_ADDRESS_SUCCESSFUL,
    payload: Add
  }
}
export const addBillAddFailed = Add => {
  return {
    type: ADD_BILL_ADDRESS_FAILED,
    payload: Add
  }
}

export const editBillAdd = (Add, history) => {
  return {
    type: EDIT_BILL_ADDRESS,
    payload: { Add, history },
  }
}

export const editBillAddSuccessful = Add => {
  return {
    type: EDIT_BILL_ADDRESS_SUCCESSFUL,
    payload: Add
  }
}
export const editBillAddFailed = Add => {
  return {
    type: EDIT_BILL_ADDRESS_FAILED,
    payload: Add
  }
}

export const getBillAdd = () => {
  return {
    type: GET_BILL_ADDRESS_DETAILS,
  }
}
export const getBillAddSuccessful = (Add) => {
  return {
    type: GET_BILL_ADDRESS_DETAILS_SUCCESSFUL,
    payload: Add
  }
}
export const getBillAddFailed = (Add) => {
  return {
    type: GET_BILL_ADDRESS_DETAILS_FAILED,
    payload: Add
  }
}

export const apiErrorBillDet = () => {
  return {
    type: API_ERROR,
  }
}

export const cardReset = () => {
  return {
    type: ADD_CARD_RESET,
  }
}
export const getTimeZonesList = (payload) => {
  return {
    type: GET_TIMEZONES_LIST,
    payload: payload
  }
}
export const updateTimeZone = (payload) => {
  return {
    type: UPDATE_TIMEZONE,
    payload: payload
  }
}
export const setTimeZonesList = (payload) => {
  return {
    type: SET_TIMEZONES_LIST,
    payload: payload
  }
}
export const setSetupPopup = (payload) => {
  return {
    type: SET_SETUP_POPUP,
    payload: payload
  }
}
export const setPayementInformation = (payload) => {
  return {
    type: SET_PAYEMENT_INFO,
    payload: payload
  }
}

